<template>
    <div class="msgDet">
        <!-- 留言详情页面 -->
        <div class="msgTitle">{{ msgData.title }}</div>
        <div class="djDiv">
            <span class="time">{{ msgData.messageTime }}</span>
            <button class="closeBtn" @click="closeMsg" v-if="msgData.status == 0 && closeType">关闭留言</button>
        </div>
        <ul class="hfUl">
            <template v-for="(item, index) in msgData.comment">
                <!-- isFlag = 3 的是用户追问的, =2的是客服回复的 -->
                <li :key="item.id" :class="{ aMsgLi: item.isFlag == 2 }">
                    <div>
                        <span class="typeBtn" v-if="item.isFlag == 3">追问</span>
                        <span class="typeBtn" v-if="item.isFlag == 2 && index != 0">追答</span>
                        {{ item.content }}
                    </div>
                    <div class="time">{{ item.strCreateDate }}</div>
                </li>
            </template>
        </ul>

        <div class="inputBox" v-if="msgData.status == 0 && closeType">
            <input v-model="msgTextarea" @keyup.enter="sendMsg" placeholder="请输入您追加的留言，我们将尽快回复" />
            <button @click="addMsg">确定</button>
        </div>
    </div>
</template>
<script>
import { Toast } from "vant";
export default {
    name: "messageDetails",
    data() {
        return {
            msgData: [],
            msgTextarea: "",
            id: "", //问题的id
            closeType: true
        };
    },
    mounted() {
        this.getData();
        this.$store.dispatch("actionsHead", { type: true, title: "智能客服", iconType: true });
    },
    methods: {
        //获取数据
        getData() {
            this.id = this.$route.params.id;
            var url = "?id=" + this.id;
            this.$get("https://customer.yuntsg.com/leave-message-front/get-reply" + url).then((res) => {
                if (res["code"] == 0) {
                    this.msgData = res["data"];
                    this.msgData.messageTime = this.msgData.messageTime.replace("T", " ");
                    for (var n in this.msgData["comment"]) {
                        var item = this.msgData["comment"][n];
                        item["strCreateDate"] = item["strCreateDate"].replace("T", " ");
                    }
                }
            });
        },
        //追加留言
        addMsg() {
            if (this.msgTextarea.split(" ").join("").length == 0) {
                Toast("请输入内容");
                return false;
            }
            var url = "?content=" + this.msgTextarea + "&id=" + this.id;
            this.$post("https://customer.yuntsg.com/leave-message-front/continue-ask" + url).then((res) => {
                if (res["code"] == 0 && res["data"] == 0) {
                    this.msgTextarea = "";
                    this.getData();
                    Toast("留言成功");
                }
            });
        },
        //关闭留言
        closeMsg() {
            var url = "?id=" + this.id;
            this.$get("https://customer.yuntsg.com/leave-message-front/close" + url).then((res) => {
                if (res["code"] == 0 && res["data"] == 0) {
                    Toast("关闭留言成功");
                    this.closeType = false;
                }
            });
        }
    }
};
</script>
<style lang="less">
.msgDet {
    background-color: #ffffff;
    color: #2f2f2f;
    font-size: 0.9rem;
    padding: 0.7rem 1rem;
    .time {
        color: #9c9c9c;
        margin-top: 0.5rem;
        font-size: 0.8rem;
    }
    .msgTitle {
        color: #262626;
    }
    .djDiv {
        vertical-align: middle;
        margin-top: 0.5rem;
        overflow: hidden;

        .closeBtn {
            color: #979797;
            border: 1px solid #979797;
            padding: 0.2rem 0.4rem;
            background-color: transparent;
            float: right;
            border-radius: 0.8rem;
        }
    }
    //追问的msg
    .hfUl {
        margin-top: 1rem;
        margin-bottom: 5rem;
        li {
            padding: 0.5rem 0.7rem;
            margin-bottom: 0.3rem;
            border-radius: 0.5rem;
            div {
                overflow: hidden;
                .typeBtn {
                    background-color: #ddedf2;
                    padding: 0.3rem 0.5rem;
                    border-radius: 0.3rem;
                    margin-right: 0.3rem;
                    display: inline-block;
                }
            }
        }
        //追答的msg
        .aMsgLi {
            background-color: #f5f5f5;
        }
    }
    .inputBox {
        width: 100%;
        height: 4rem;
        position: fixed;
        bottom: 0rem;
        left: 0rem;
        border-top: 1px solid #e5e9ee;
        padding: 0.7rem 0 0 1rem;
        background-color: #ffffff;
        input {
            background-color: #f5f5f5;
            height: 2rem;
            border-radius: 0.8rem 0 0 0.8rem;
            outline: none;
            border: none;
            padding: 0.5rem;
            width: 77%;
            margin-right: 5%;
        }
        button {
            border: none;
            background-color: #0689e7;
            color: #ffffff;
            width: 15%;
            height: 2rem;
            border-radius: 0.8rem;
        }
    }
}
</style>
